import { useState, useEffect } from 'react'
import {useDispatch } from 'react-redux'
import {toast} from 'react-toastify'

const useDependentResource = ({
    selector,
    getReducer,
    resetReducer,
    renderTableData,
    routes: {
        getRoute
    }
}) => {
    const [tableData, setTableData] = useState([]);
    const dispatch = useDispatch();

    const {
        data,
        isError,
        isLoading,
        isSuccess,
        message
    } = selector;


    useEffect(() => {
        if (isError) {
            toast.error(message)
            
        }

        if (isSuccess) {
            
        }

        if (isSuccess && message) {
            toast.success(message);
        }

        if (isSuccess && data) {
            prepareTableData(data);
        }

        dispatch(resetReducer())
        // eslint-disable-next-line
    }, [data, isError, isSuccess, message])

    const prepareTableData = (response) => {
        setTableData(renderTableData(response));
    }

    useEffect(() => {
        dispatch(getReducer(getRoute));
        // eslint-disable-next-line
    }, [dispatch]);

    return {
        data: tableData,
        isLoading: isLoading,
    };
};

export default useDependentResource;